<form class="search-filters__form"
      fxFlex
      fxLayout="column"
      name="searchForm">
    <div class="search-filters__container"
         fxFlex="1 1 100"
         fxLayout="row wrap"
         fxLayoutAlign="start center"
         fxLayoutGap="24px">
        <ng-container *ngFor="let field of fieldsFormatedForDirective">
            <mat-form-field *ngIf="field==='type'" [floatLabel]="floatLabel">
                <!--TODO replace 'projects-management.lesson_space' by a value coming form input because it could have two value-->
                <mat-label>{{ getFieldTerms('type') !== '' ? (getFieldTerms('type') | translate) : ('generic.type_global_corpus' | translate) }}</mat-label>
                <mat-select name="typeFilter"
                            [formControl]="controls['typeFilter'].formControl">
                    <mat-option value="all">
                        <mat-icon *ngIf="displayedFiltersIcons" svgIcon="allTypes" title="audio"></mat-icon>
                        {{ 'generic.all' | translate }}
                    </mat-option>
                    <mat-option *ngFor="let type of customLists['types']" [value]="type.id" appAriaTitle>
                    <span *ngIf="type.id === 'audio'"><mat-icon *ngIf="displayedFiltersIcons" svgIcon="audio"
                                                                title="audio"></mat-icon>
                        {{ 'generic.audio' | translate }}</span>
                        <span *ngIf="type.id === 'document'"><mat-icon *ngIf="displayedFiltersIcons" svgIcon="document"
                                                                       title="audio"></mat-icon>
                            {{ 'generic.document' | translate }}</span>
                        <span *ngIf="type.id === 'image'"><mat-icon *ngIf="displayedFiltersIcons" svgIcon="image"
                                                                    title="audio"></mat-icon>
                            {{ 'generic.image' | translate }}</span>
                        <span *ngIf="type.id === 'media'"><mat-icon *ngIf="displayedFiltersIcons" svgIcon="media"
                                                                    title="audio"></mat-icon>
                            {{ 'generic.media' | translate }}</span>
                        <span *ngIf="type.id === 'text'"><mat-icon *ngIf="displayedFiltersIcons" svgIcon="text"
                                                                   title="audio"></mat-icon>
                            {{ 'generic.text' | translate }}</span>
                        <span *ngIf="type.id === 'url'"><mat-icon *ngIf="displayedFiltersIcons" svgIcon="url"
                                                                  title="audio"></mat-icon>
                            {{ 'generic.url' | translate }}</span>
                        <span *ngIf="type.id === 'video'"><mat-icon *ngIf="displayedFiltersIcons" svgIcon="video"
                                                                    title="audio"></mat-icon>
                            {{ 'generic.video' | translate }}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!--TODO replace generic.title by a value coming form input because it could have multiple value-->
            <mat-form-field class="filters-field-title" *ngIf="field==='title'" [floatLabel]="floatLabel">
                <mat-label>{{ getFieldTerms('title') !== '' && getFieldTerms('title') !== 'generic.title' ? (getFieldTerms('title') | translate) : defaultFieldTitle }}</mat-label>
                <input #titleInput="matInput" matInput [formControl]="controls['titleFilter'].formControl"
                       data-e2e="search-filter-title"
                >
            </mat-form-field>

            <mat-form-field class="filters-field-metadatas_title" *ngIf="field==='metadatas_title'" [floatLabel]="floatLabel">
                <mat-label>{{ getFieldTerms('metadatas_title') !== '' && getFieldTerms('title') !== 'generic.title' ? (getFieldTerms('metadatas_title') | translate) : defaultFieldTitle }}</mat-label>
                <input #titleInput="matInput" matInput [formControl]="controls['metadatas_title'].formControl"
                       data-e2e="search-filter-metadata-title"
                >
            </mat-form-field>

            <mat-form-field class="filters-field-skills" *ngIf="field==='skills'" [floatLabel]="floatLabel">
                <mat-label>{{ 'generic.skills' | translate }}</mat-label>
                <mat-select
                    name="searchSkillsFilter"
                    [formControl]="controls['searchSkillsFilter'].formControl"
                >
                    <mat-option appAriaTitle [value]="'all'">{{ 'generic.all' | translate }}</mat-option>
                    <mat-option appAriaTitle *ngFor="let skills of dataLists['skills']" [value]="skills.id">
                        <span>{{ skills.get('label') }}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="filters-field-difficulty" *ngIf="field==='difficulty'" [floatLabel]="floatLabel">
                <mat-label>{{ 'generic.difficulty' | translate }}</mat-label>
                <mat-select name="difficultyFilter"
                            [formControl]="controls['difficultyFilter'].formControl">
                    <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
                    <mat-option appAriaTitle *ngFor="let difficulty of dataLists['difficulty']" [value]="difficulty.id">
                        {{ difficulty.get('label') }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="filters-field-usage" *ngIf="field==='usage'" [floatLabel]="floatLabel">
                <mat-label>{{ 'generic.usage' | translate }}</mat-label>
                <mat-select name="difficultyFilter"
                            [formControl]="controls['usageFilter'].formControl">
                    <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
                    <mat-option appAriaTitle *ngFor="let usage of dataLists['usage']" [value]="usage.id">
                        {{ (usage.get('label') | translate) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="filters-field-educationnalLevel" *ngIf="field==='educationnalLevel' && !displayField('educationnalLevel-toogle')"  [floatLabel]="floatLabel">
                <mat-label>{{ 'generic.level' | translate }}</mat-label>
                <mat-select name="educationnalLevelFilter"
                            [formControl]="controls['educationnalLevelFilter'].formControl">
                    <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
                    <mat-option appAriaTitle *ngFor="let level of dataLists['educational_level']" [value]="level.id">
                        {{ level.get('label') }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="filters-field-method" *ngIf="field==='method'" [floatLabel]="floatLabel">
                <mat-label>{{ 'licensing.method' | translate }}</mat-label>
                <mat-select name="licenseFilter" [formControl]="controls['licenseFilter'].formControl"
                >
                    <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
                    <mat-option appAriaTitle [value]="method.id" *ngFor="let method of customLists['methods']">
                        {{ method.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="field==='chapters' && !displayField('chapters-toogle')"
                            class="search-filters__chapter-field filters-field-chapters" [floatLabel]="floatLabel">
                <mat-label>{{ 'generic.chapters' | translate }}</mat-label>
                <mat-select name="chaptersFilter"

                            [formControl]="controls['chaptersFilter'].formControl">
                    <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
                    <mat-option appAriaTitle *ngFor="let chapters of dataLists['chapters']"
                                [value]="chapters.id">
                        {{ chapters.get('label') }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- This version use button list whith only one choice possible -->
            <div *ngIf="field==='chapters-toogle'"
                 class="search-filters__chapter-toggle filters-field-chapters">
                <mat-button-toggle-group class="search-filters__toggle-group"
                                         name="chaptersFilter"
                                         hideSingleSelectionIndicator="true"
                                         [formControl]="controls['chaptersFilter'].formControl">
                    <mat-button-toggle *ngFor="let chapter of dataLists['chapters']; let index = index;"
                                       class="search-filters__toggle-button-wrapper exclude-elem-to-order-directive"
                                       [class.selected]="controls['chaptersFilter'].formControl.value === chapter.id"
                                       [class.search-filters__toggle-button-wrapper--selected]="controls['chaptersFilter'].formControl.value === chapter.id"
                                       [value]="chapter.id"
                                       (click)="launchSearch()"
                                       data-e2e="search-filters-lanch-search-155">
                        {{ chapter.get('label') }}
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>

            <mat-form-field class="filters-field-concepts" *ngIf="field==='concepts'" [floatLabel]="floatLabel">
                <mat-label>{{ 'generic.concepts' | translate }}</mat-label>
                <mat-select name="conceptsFilter"
                            [formControl]="controls['conceptsFilter'].formControl">
                    <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
                    <mat-option appAriaTitle *ngFor="let concepts of dataLists['concepts']" [value]="concepts.id">
                        {{ concepts.get('label') }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="filters-field-thematics" *ngIf="field==='thematics'" [floatLabel]="floatLabel">
                <mat-label>{{ 'generic.thematics' | translate }}</mat-label>
                <mat-select name="thematicsFilter"
                            [formControl]="controls['thematicsFilter'].formControl">
                    <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
                    <mat-option appAriaTitle *ngFor="let thematics of dataLists['thematics']" [value]="thematics.id">
                        {{ thematics.get('label') }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="filters-field-notions" *ngIf="field==='notions'" [floatLabel]="floatLabel">
                <mat-label>{{ 'generic.notions' | translate }}</mat-label>
                <mat-select name="notionsFilter"
                            [formControl]="controls['notionsFilter'].formControl">
                    <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
                    <mat-option appAriaTitle *ngFor="let notions of dataLists['notions']" [value]="notions.id">
                        {{ notions.get('label') }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="filters-field-assignation_type" *ngIf="field==='assignation_type'" [floatLabel]="floatLabel">
                <mat-label>{{ 'generic.type' | translate }}</mat-label>
                <mat-select name="assignation_typeFilter"
                            [formControl]="controls['assignation_typeFilter'].formControl">
                    <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
                    <mat-option appAriaTitle *ngFor="let assignation_type of dataLists['assignation_type']"
                                [value]="assignation_type.id">
                        {{ localizedType(assignation_type.get('label')) | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="filters-field-schoolyears" *ngIf="field==='schoolyears'" [floatLabel]="floatLabel">
                <mat-label>{{ 'groups-management.chose_school.year' | translate }}</mat-label>
                <mat-select name="schoolyearsFilter" [formControl]="controls['schoolyearsFilter'].formControl"
                >
                    <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
                    <mat-option appAriaTitle
                                *ngFor="let shoolyear of dataLists['schoolyears']"
                                [value]="shoolyear.id">{{ displaySchoolYear(shoolyear.get('name')) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="filters-field-lessons" *ngIf="field==='lessons'" [floatLabel]="floatLabel">
                <mat-label>{{ 'generic.lessons' | translate }}</mat-label>
                <mat-select name="lessonsFilter" [formControl]="controls['lessonsFilter'].formControl"
                >
                    <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
                    <mat-option appAriaTitle [value]="lesson.id" *ngFor="let lesson of customLists['lessons']">
                        {{ lesson.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!--author is also use for theme todo field name placeholder -->
            <mat-form-field class="filters-field-author" *ngIf="field==='author'" [floatLabel]="floatLabel">
                <mat-label>{{ getFieldTerms('author') !== '' ? (getFieldTerms('author') | translate) : ('generic.author_global_corpus' | translate) }}</mat-label>
                <input matInput [formControl]="controls['authorFilter'].formControl"
                       data-e2e="search-filter-author"
                >
            </mat-form-field>

            <!--group is also use for niveau todo field name placeholder-->
            <mat-form-field class="filters-field-group" *ngIf="field==='group'" [floatLabel]="floatLabel">
                <mat-label>{{ getFieldTerms('group') !== '' ? (getFieldTerms('group') | translate) : ('generic.group_global_corpus' | translate) }}</mat-label>
                <input matInput [formControl]="controls['groupFilter'].formControl"
                       data-e2e="search-filter-group"
                >
            </mat-form-field>


            <button *ngIf="field==='launchSearch'" class="search-filters__search-button filters-field-launchSearch"
                    data-e2e="search-filters-lanch-search-246"
                    (click)="launchSearch()">
                {{ 'generic.search' | translate }}
            </button>

            <span *ngIf="field==='countEntities'"
                  class="filters-field-countEntities"
                  fxlayout="row"
                  fxlayoutalign="start center">
            {{ countEntities }} {{ (countEntities < 2 ? 'generic.result' : 'generic.results') | translate }}
        </span>

            <mat-checkbox *ngIf="field==='bookmarks'"
                          class="search-filters__bookmark-checkbox filters-field-bookmarks"
                          name="filterBookmarks"
                          [formControl]="controls['searchBookmarkFilter'].formControl"
                          (change)="launchSearch()">
                {{ 'generic.filter_by_bookmarks' | translate }}
            </mat-checkbox>

            <mat-checkbox *ngIf="field==='autocorrection'"
                          class="search-filters__autocorrect-checkbox"
                          name="filterAutocorrection"
                          [formControl]="controls['searchAutocorrectionFilter']?.formControl"
                          (change)="launchSearch()">
                {{ 'generic.filter_by_autocorrection' | translate }}
            </mat-checkbox>
        </ng-container>
    </div>
</form>
